<template>
  <div class="sn-f-col-b-s doctor">
    <div class="sn-f-s-0 sn-f-b-e" style="width: 100%;">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_GHYY),
        replace: true,
        router: $sn.getConfig('pcEntranceArea') ? '/appointment/area' : '/appointment/depart',
      }, {
        title: '选择号源'
      }]"></sn-breadcrumb>
      <div class="sn-f-e-c sn-search">
        <input placeholder="搜索医生、科室、疾病" v-model="dynamic" @keyup.enter="navigateUrl('/appointment/search', '', {
          dynamic: dynamic ? encodeURIComponent(dynamic) : '',
          business: doctorInfo.businessType || perpetual.BASIC_BUSINESS_OFFLINE_CKQBYS
        });"/>
        <div class="sn-f-c-c interaction" @click="navigateUrl('/appointment/search', '', {
          dynamic: dynamic ? encodeURIComponent(dynamic) : '',
          business: doctorInfo.businessType || perpetual.BASIC_BUSINESS_OFFLINE_CKQBYS
        });">查询</div>
      </div>
    </div>
    <div class="sn-f-1 doctor-region">
      <template v-if="doctorInfo.doctorId">
        <div class="sn-f-b-c basic">
          <sn-head-photo :src="doctorInfo.doctorPicture" :width="120" :height="160"></sn-head-photo>
          <div class="sn-f-1 sn-f-col-b-s doctor-info">
            <div class="sn-f-s-c">
              <div class="sn-fs-32 sn-fw-bold">{{ doctorInfo.doctorName }}</div>
              <div class="sn-f-col-c-s doctor-sub" v-if="doctorInfo.deptName || doctorInfo.doctorTitle">
                <div v-if="doctorInfo.deptName">{{ doctorInfo.deptName }}</div>
                <div v-if="doctorInfo.doctorTitle">{{ doctorInfo.doctorTitle }}</div>
              </div>
            </div>
            <div class="sn-f-1 doctor-caption">
              <div>医生介绍：&nbsp;&nbsp;{{ doctorInfo.doctorIntroduce || '暂无' }}</div>
              <div>医生擅长：&nbsp;&nbsp;{{ doctorInfo.doctorSkill || '暂无' }}</div>
            </div>
          </div>
          <div class="depart-info" v-if="departDoctor.length > 0">
            <div class="sn-f-b-e sn-title">
              <div class="sn-f-c-c title-caption">同科室医生</div>
              <div class="sn-f-e-c sn-pointer title-sub sn-fc-main" @click="navigateUrl('/appointment/depart', '', {
                areaId: selectedArea.areaId,
                deptId: doctorInfo.deptId,
                businessType: doctorInfo.businessType || perpetual.BASIC_BUSINESS_OFFLINE_CKQBYS
              }, 'replace');">
                <div>查看全部</div>
                <div class="iconfont icon-xiangyou sn-fc-main"></div>
              </div>
            </div>
            <div class="sn-f-s-c sn-f-wrap depart-doctor">
              <div class="sn-pointer sn-omit doctor-recommend"
              :key="doctor.doctorId" v-for="doctor in departDoctor.slice(0, 6)" @click="navigateUrl('exchange-doctor', doctor);">
                {{ doctor.doctorName }}<template v-if="doctor.doctorTitle">&nbsp;/&nbsp;{{ doctor.doctorTitle }}</template>
              </div>
            </div>
          </div>
        </div>
        <div class="sn-f-b-c" v-if="areaList.length > 1 || pagination('0')">
          <div class="sn-f-s-0">
            <div class="sn-f-s-c area" v-if="areaList.length > 1">
              <div class="sn-f-c-c sn-pointer area-blank" :class="{'interaction': area.areaId === selectedArea.areaId}"
              :key="area.areaId" v-for="area in areaList" @click="navigateUrl('exchange-area', area);">{{ area.areaName }}</div>
            </div>
          </div>
          <div class="sn-f-e-c pagination" v-if="pagination('0')">
            <div class="sn-f-c-c sn-pointer pagination-blank" :class="{'interaction': pagination('1')}" @click="pagination('1') ? pageCount-- : null;">上一周</div>
            <div class="sn-f-c-c sn-pointer pagination-blank" :class="{'interaction': pagination('2')}" @click="pagination('2') ? pageCount++ : null;">下一周</div>
          </div>
        </div>
        <div class="schedule-blank">
          <template v-if="scheduleInfo.length > 0">
            <div class="sn-f-c-c schedule-top">专家坐诊表</div>
            <div class="chart-blank">
              <div class="sn-f-s-c chart-line">
                <div class="sn-f-1 sn-f-col-c-c chart-single" :key="i" v-for="(date, i) in tableExhibition">
                  <template v-if="date">
                    <div>{{ $sn.format.date(new Date(date), 'MM-dd') }}</div>
                    <div>周{{ $sn.format.day(date) }}</div>
                  </template>
                </div>
              </div>
              <div class="sn-f-s-c chart-line" :key="k" v-for="(item, k) in scheduleExhibition">
                <div class="sn-f-1 sn-f-col-c-c chart-single">
                  <div>{{ $sn.format.getQuality(periodInfo, k + '.itemName') }}</div>
                </div>
                <div class="sn-f-1 sn-f-col-c-c sn-pointer chart-single"
                :class="schedulePattern(schedule)"
                :key="serial" v-for="(schedule, serial) in item" @click="!$sn.validate.empty(schedule) ? goAppointment(schedule[0]) : null;">
                  <template v-if="$sn.validate.empty(schedule)">--</template>
                  <template v-else>
                    <div>{{ (['挂号', '预约'].includes(scheduleStatus(schedule[0])) ? '点击' : '') + scheduleStatus(schedule[0]) }}</div>
                    <div v-if="isShowScheduleCostAppointment && parseFloat(schedule[0].regFee) > 0">￥{{ schedule[0].regFee }}</div>
                    <div v-if="['挂号', '预约'].includes(scheduleStatus(schedule[0]))">剩余号源：{{ schedule[0].surplusNumber }}</div>
                  </template>
                </div>
              </div>
            </div>
            <template v-if="scheduleTimeInfo.length > 0">
              <div class="sn-f-b-e sn-title">
                <div class="sn-f-c-c title-caption">
                  选择号源&nbsp;&nbsp;
                  周{{ $sn.format.day(selected.scheduleDate) + '（' + $sn.format.date(new Date(selected.scheduleDate), 'MM-dd') + '）' }}
                  &nbsp;/&nbsp;
                  {{ $sn.format.getQuality(periodInfo, selected.scheduleNoonCode + '.itemName') }}
                </div>
                <div class="sn-f-e-c title-sub">
                  <div class="sn-fc-red1">*</div>
                  <div class="sn-fc-text3">选择候诊时间</div>
                </div>
              </div>
              <div class="sn-f-s-c sn-f-wrap schedule-time">
                <div class="sn-f-c-c region" :key="time.timeId" v-for="time in scheduleTimeInfo">
                  <div class="sn-f-c-c sn-pointer single" :class="{'sn-silence': parseFloat(time.surplusNumber) <= 0 || time.state !== '1'}" @click="navigateUrl('/appointment/confirm', time);">
                    <template v-if="!isScheduleTimeSerialPostPosition && seq(time)">
                      <div class="sn-fw-bold">{{ seq(time) > 9 ? seq(time) : '0' + seq(time) }}</div>[
                    </template>
                    <div>{{ time.startTime.substring(0, 5) }}</div>
                    <div v-if="time.endTime">&nbsp;-&nbsp;{{ time.endTime.substring(0, 5) }}</div>
                    <template v-if="seq(time)">
                      <div v-if="isScheduleTimeSerialPostPosition">[{{ seq(time) > 9 ? seq(time) : '0' + seq(time) }}]</div>
                      <template v-else>]</template>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </template>
          <sn-no-data message="暂无排班" v-else></sn-no-data>
        </div>
      </template>
      <sn-no-data v-else></sn-no-data>
    </div>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger.js';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import AppointmentMixin from '@/pages/appointment/appointment-mixin';
import * as Messages from '@/common/utils/messages';

export default {
  mixins: [HomepageMixin, AppointmentMixin],
  data() {
    return {
      pageParams: {},
      dynamic: '',
      doctorInfo: self.$sn.utils.getHospitalLocalStorage('Appointment_DoctorInfo'),
      areaList: self.$sn.utils.getHospitalAreaInformation(),
      selectedArea: {},
      departDoctor: [],
      scheduleInfo: [],
      scheduleInfoFormat: {},
      tableInfo: {
        date: [],
        noon: []
      },
      pageCount: 1,
      selected: {},
      scheduleTimeInfo: [],
      scheduleEndDateRestrictTime: self.$sn.getConfig('scheduleEndDateRestrictTime'),
      isScheduleTimeSerialPostPosition: self.$sn.getConfig('isScheduleTimeSerialPostPosition')
    };
  },
  computed: {
    pagination() {
      // 0：是否存在分页；1：上一页是否可用；2：下一页是否可用
      return (type) => {
        const standard = this.$sn.getConfig('showScheduleDay');
        let verify = false;
        if (!this.$sn.validate.empty(this.scheduleInfoFormat)) {
          if (type === '0') {
            Object.keys(this.scheduleInfoFormat).forEach(noon => {
              if (!this.$sn.validate.empty(this.scheduleInfoFormat[noon])) {
                if (this.$sn.format.group(this.scheduleInfoFormat[noon], standard).length > 1) verify = true;
              }
            });
          }
          else if (type === '1') {
            if (this.pageCount > 1) verify = true;
          }
          else if (type === '2') {
            Object.keys(this.scheduleInfoFormat).forEach(noon => {
              if (!this.$sn.validate.empty(this.scheduleInfoFormat[noon])) {
                if (!this.$sn.validate.empty(this.$sn.format.group(this.scheduleInfoFormat[noon], standard)[this.pageCount])) verify = true;
              }
            });
          }
        }
        return verify;
      };
    },
    tableExhibition() {
      const standard = this.$sn.getConfig('showScheduleDay');
      const digit = [''];
      if (!this.$sn.validate.empty(this.tableInfo.date)) {
        this.$sn.format.group(this.tableInfo.date, standard)[this.pageCount - 1].forEach(el => {
          digit.push(el);
        });
      }
      return digit;
    },
    scheduleExhibition() {
      const standard = this.$sn.getConfig('showScheduleDay');
      const digit = {};
      const schedule = this.$sn.format.clone(this.scheduleInfoFormat);
      if (!this.$sn.validate.empty(schedule)) {
        Object.keys(schedule).forEach(noon => {
          if (!this.$sn.validate.empty(schedule[noon])) {
            this.$set(digit, noon, this.$sn.format.group(schedule[noon], standard)[this.pageCount - 1]);
          }
        });
      }
      return digit;
    },
    schedulePattern() {
      return (schedule) => {
        let pattern = '';
        if (!this.$sn.validate.empty(schedule)) {
          if (this.selected.scheduleItemCode === schedule[0].scheduleItemCode) pattern = 'interaction';
          else if (['挂号', '预约'].includes(this.scheduleStatus(schedule[0]))) pattern = 'exist';
          else pattern = 'disabled';
        }
        return pattern;
      };
    },
    scheduleStatus() {
      return (schedule) => {
        if (schedule.isStop === '1') return '停诊';
        if (parseFloat(schedule.surplusNumber) === -1) return '加载中';
        if (parseFloat(schedule.surplusNumber) === -2) return '请重试';
        if (parseFloat(schedule.surplusNumber) === -3) {
          if (this.$sn.getConfig('scheduleEmptyOtherNoContent')) return this.$sn.getConfig('scheduleEmptyOtherNoContent');
          else return schedule.scheduleDate === this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd') ? this.$sn.getConfig('todayScheduleFullOtherNoContent') : this.$sn.getConfig('scheduleFullOtherNoContent');
        }
        if (parseFloat(schedule.surplusNumber) === 0) return schedule.scheduleDate === this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd') ? this.$sn.getConfig('todayScheduleFullOtherNoContent') : this.$sn.getConfig('scheduleFullOtherNoContent');
        if (schedule.scheduleDate === this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')) {
          if (this.$sn.getConfig('isTodayScheduleDirectRegister') ||
          (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_JNRM && schedule.hosArea === '1' && schedule.deptId === '发热专业')) {
            if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SZY) {
              if (schedule.scheduleAddress.indexOf('#0') > -1) return '请到医院分诊台问询';
              if (this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < this.dawnTodayRegisterStartTime) {
                return this.dawnTodayRegisterStartTime.substring(0, 2) + ':' + this.dawnTodayRegisterStartTime.substring(2, 4) + '开放' + this.appointmentContent;
              }
            }
            if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && schedule.scheduleLevel === '5') {
              return this.perpetual.HOSPITAL_ID_SDSL + this.appointmentContent;
            }
            else return this.appointmentContent;
          }
          else return '请到医院分诊台问询';
        }
        else {
          let start = '';
          let end = '';
          if (this.$sn.getConfig('isShowTodaySchedule')) {
            if (this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < this.$sn.getConfig('scheduleReleaseTime')) {
              start = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd');
            }
            else start = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', 1, 'day');
          }
          else start = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', 1, 'day');
          if (this.$sn.getConfig('isObtainScheduleSendEndDate')) {
            end = this.$sn.format.date(new Date(start), 'yyyy-MM-dd', this.$sn.getConfig('showScheduleDay') - 1, 'day');
          }
          if (this.$sn.getConfig('isRestrictEndDateSchedule') && schedule.scheduleDate === end && this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < this.scheduleEndDateRestrictTime) {
            return this.scheduleEndDateRestrictTime.substring(0, 2) + ':' + this.scheduleEndDateRestrictTime.substring(2, 4) + '开放' + this.appointmentContent;
          }
          else return this.appointmentContent;
        }
      };
    },
    seq() {
      return (time) => {
        const config = this.$sn.getConfig('isShowScheduleTimeSeq');
        let seq = '';
        if (config === 1 || (config === 2 && time.seq && time.seq > 0)) {
          seq = time.seq;
        }
        return seq;
      };
    }
  },
  created: function() {
    if (this.$sn.utils.getHospitalSessionStorage('Appointment_SelectedScheduleTimeInfo')) {
      this.$sn.utils.removeHospitalSessionStorage('Appointment_SelectedScheduleTimeInfo');
    }
    this.pageParams = this.$route.query;
    if (this.pageParams.doctorId) {
      this.doctorInfo = {};
      if (this.$sn.utils.getHospitalLocalStorage('Appointment_DoctorInfo')) {
        this.$sn.utils.removeHospitalLocalStorage('Appointment_DoctorInfo');
      }
    }
    this.initialDoctorHomepage();
  },
  methods: {
    async initialDoctorHomepage() {
      this.$sn.assembly.loading(true);
      await this.appointment_mixin_period();
      this.$sn.assembly.loading(false);
      if (this.pageParams.doctorId) {
        this.$sn.assembly.loading(true);
        const doctor = await this.homepage_mixin_getDoctorInfoByCondition(this.pageParams, this.pageParams);
        this.$sn.assembly.loading(false);
        if (doctor.code === 0) {
          let serial = 0;
          if (this.pageParams.departId && doctor.data.findIndex(result => result.deptId === this.pageParams.departId) > -1) {
            serial = doctor.data.findIndex(result => result.deptId === this.pageParams.departId);
          }
          this.doctorInfo = doctor.data[serial];
          this.$sn.utils.setHospitalLocalStorage('Appointment_DoctorInfo', this.doctorInfo);
        }
      }
      if (this.doctorInfo.doctorId) {
        this.formatDoctorInfo();
      }
    },
    formatDoctorInfo() {
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && this.doctorInfo.frontExtend && this.$sn.validate.json(this.doctorInfo.frontExtend) && JSON.parse(this.doctorInfo.frontExtend).ZL === '1') {
        const extend = JSON.parse(this.doctorInfo.frontExtend);
        delete extend.ZL;
        this.doctorInfo.frontExtend = JSON.stringify(extend);
      }
      const area = this.doctorInfo.hosArea || this.$sn.utils.getHospitalAreaId();
      this.selectedArea = this.areaList.find(el => el.areaId === area);
      this.getDoctorSchedule();
      this.getDepartDoctor();
    },
    getDoctorSchedule() {
      let start = '';
      let end = '';
      if (this.$sn.getConfig('isShowTodaySchedule')) {
        if (this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < this.$sn.getConfig('scheduleReleaseTime')) {
          start = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd');
        }
        else {
          start = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', 1, 'day');
        }
      }
      else {
        start = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', 1, 'day');
      }
      if (this.$sn.getConfig('isObtainScheduleSendEndDate')) {
        end = this.$sn.format.date(new Date(start), 'yyyy-MM-dd', this.$sn.getConfig('showScheduleDay') - 1, 'day');
      }
      if (this.doctorInfo.businessType === this.perpetual.BASIC_BUSINESS_OFFLINE_ZKLMJZYY) end = '';
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        url: Swagger.getOfflineDoctorScheduleInfoByCondition,
        query: {
          hosId: this.$sn.utils.getHospitalId(),
          hosArea: this.selectedArea.areaId,
          deptId: this.doctorInfo.deptId,
          doctorId: this.doctorInfo.doctorId,
          type: '1',
          businessType: this.doctorInfo.businessType || this.perpetual.BASIC_BUSINESS_OFFLINE_CKQBYS,
          start: start,
          end: end
        },
        header: true
      }).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data && result.data.length > 0) {
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_QDQL) {
            if (!this.doctorInfo.frontExtend || !this.$sn.validate.json(this.doctorInfo.frontExtend) || !JSON.parse(this.doctorInfo.frontExtend).jointDoctor) {
              result.data = result.data.filter(res => !res.frontExtend || !this.$sn.validate.json(res.frontExtend) || !JSON.parse(res.frontExtend).jointDoctor);
            }
          }
          else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_QDYK) {
            result.data = result.data.filter(res => res.deptId.indexOf('_zbmz') === -1);
          }
          else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
            result.data = result.data.filter(res => !res.frontExtend || !this.$sn.validate.json(res.frontExtend) || JSON.parse(res.frontExtend).ZL !== '1');
          }
          result.data.forEach(el => {
            this.scheduleInfo = this.scheduleInfo.concat(el.schedules);
          });
          let max = this.scheduleInfo[0].scheduleDate;
          this.scheduleInfo.forEach(el => {
            if (el.scheduleDate > max) max = el.scheduleDate;
          });
          for (let i = 1; ; i++) {
            if (this.$sn.format.date(new Date(start), 'yyyy-MM-dd', i * this.$sn.getConfig('showScheduleDay') - 1, 'day') >= max) {
              end = this.$sn.format.date(new Date(start), 'yyyy-MM-dd', i * this.$sn.getConfig('showScheduleDay') - 1, 'day');
              break;
            }
          }
          for (let i = 0; ; i++) {
            const date = this.$sn.format.date(new Date(start), 'yyyy-MM-dd', i, 'day');
            this.tableInfo.date.push(date);
            if (date === end) break;
          }
          this.getDoctorScheduleOtherNo();
        }
      });
    },
    getDoctorScheduleOtherNo() {
      this.scheduleInfo.forEach(el => {
        el.surplusNumber = -1;
      });
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        url: Swagger.getOfflineScheduleOtherNoByCondition,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          businessType: this.doctorInfo.businessType || this.perpetual.BASIC_BUSINESS_OFFLINE_CKQBYS,
          deptId: this.doctorInfo.deptId,
          doctorId: this.doctorInfo.doctorId,
          hosId: this.$sn.utils.getHospitalId(),
          platformType: this.$sn.utils.getPlatformType()
        })
      }).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data && result.data.length > 0) {
          this.scheduleInfo.forEach(el => {
            el.surplusNumber = -3;
            const fructify = result.data.find(res => res.schId === el.scheduleItemCode && res.businessType === el.businessType);
            if (!this.$sn.validate.empty(fructify)) {
              el.surplusNumber = fructify.remain;
              el.resNo = fructify.sumNo;
            }
          });
        }
        else {
          this.scheduleInfo.forEach(el => {
            el.surplusNumber = -2;
          });
        }
        const scheduleFormat = [];
        // 处理排班一：初始化排班信息，按照院区信息进行分组
        this.areaList.forEach(el => {
          scheduleFormat.push({
            ...el,
            schedule: []
          });
        });
        /*
        处理排班二：将排班按照排班日期及科室 ID 进行分组
        scheduleDate[string]：排班日期
        deptId[string]：排班科室 ID，仅用于组数据时处理
        caption[array]：排班科室名称，预留后续进行处理
        schedule[array]：排班信息
        */
        scheduleFormat.forEach(area => {
          this.scheduleInfo.filter(res => res.hosArea === area.areaId).forEach(schedule => {
            if (this.$sn.validate.empty(area.schedule.find(res => res.scheduleDate === schedule.scheduleDate && res.deptId === schedule.deptId))) {
              area.schedule.push({
                scheduleDate: schedule.scheduleDate,
                deptId: schedule.deptId,
                caption: [],
                schedule: [schedule]
              });
            }
            else {
              const serial = area.schedule.findIndex(res => res.scheduleDate === schedule.scheduleDate && res.deptId === schedule.deptId);
              area.schedule[serial].schedule.push(schedule);
            }
          });
        });
        const compare = (schedule) => {
          if (schedule.isStop !== '1' && parseFloat(schedule.surplusNumber) > 0) return 0;
          if (Object.keys(schedule).filter(k => k.indexOf('candidate') > -1).length > 0) return 1;
          return 2;
        };
        scheduleFormat.forEach(area => {
          area.schedule = this.$sn.format.digitalSort(area.schedule, '1', 'scheduleDate');
          area.schedule.forEach(schedule => {
            schedule.schedule.sort((val1, val2) => {
              const noon1 = this.periodInfo[val1.scheduleNoonCode].itemOrder;
              const noon2 = this.periodInfo[val2.scheduleNoonCode].itemOrder;
              if (noon1 < noon2) return -1;
              if (noon1 > noon2) return 1;
              const value1 = compare(val1);
              const value2 = compare(val2);
              if (value1 < value2) return -1;
              if (value1 > value2) return 1;
              return 0;
            });
          });
        });
        this.tableInfo.noon = this.$sn.getConfig('initialTableSchedulePeriod');
        scheduleFormat.forEach(area => {
          area.schedule.forEach(schedule => {
            schedule.schedule.forEach(el => {
              if (this.$sn.validate.empty(this.tableInfo.noon.find(res => res === el.scheduleNoonCode))) {
                this.tableInfo.noon.push(el.scheduleNoonCode);
              }
            });
          });
        });
        this.tableInfo.noon.sort((val1, val2) => {
          if (this.periodInfo[val1].itemOrder < this.periodInfo[val2].itemOrder) return -1;
          if (this.periodInfo[val1].itemOrder > this.periodInfo[val2].itemOrder) return 1;
          return 0;
        });
        this.tableInfo.noon.forEach(el => {
          this.$set(this.scheduleInfoFormat, el, []);
          this.tableInfo.date.forEach(element => {
            if (element) this.scheduleInfoFormat[el].push([]);
          });
        });
        scheduleFormat.forEach(area => {
          area.schedule.forEach(schedule => {
            schedule.schedule.forEach(el => {
              let verify = true;
              if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_QDYK) {
                verify = this.$sn.validate.empty(this.scheduleInfoFormat[el.scheduleNoonCode][this.tableInfo.date.findIndex(res => res === el.scheduleDate)].find(res => res.deptName === el.deptName));
              }
              if (verify) {
                this.scheduleInfoFormat[el.scheduleNoonCode][this.tableInfo.date.findIndex(res => res === el.scheduleDate)].push(el);
              }
            });
          });
        });
      });
    },
    getDepartDoctor() {
      const params = {
        url: Swagger.getOfflineDoctorInfoByCondition,
        query: {
          hosId: this.$sn.utils.getHospitalId(),
          hosArea: this.selectedArea.areaId,
          businessType: this.doctorInfo.businessType || this.perpetual.BASIC_BUSINESS_OFFLINE_CKQBYS,
          deptId: this.doctorInfo.deptId
        },
        header: true
      };
      this.$sn.utils.ordinaryRequest(params).then(result => {
        if (result && result.code === 0 && result.data && result.data.length > 0) {
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_QDQL) {
            if (this.doctorInfo.frontExtend && this.$sn.validate.json(this.doctorInfo.frontExtend) && JSON.parse(this.doctorInfo.frontExtend).jointDoctor) {
              this.$set(this.doctorInfo, 'combined', []);
              JSON.parse(this.doctorInfo.frontExtend).jointDoctor.split('|').forEach(el => {
                if (!this.$sn.validate.empty(result.data.find(res => res.doctorId === el)) && result.data.find(res => res.docId === el).doctorId) {
                  this.doctorInfo.combined.push(result.data.find(res => res.doctorId === el));
                }
              });
              return false;
            }
          }
          this.departDoctor = result.data.filter(res => res.doctorId !== this.doctorInfo.doctorId && res.doctorTitle !== '普通');
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDQL) {
            this.departDoctor = this.departDoctor.filter(res => res.doctorId !== '1216');
          }
          this.departDoctor = this.appointment_mixin_compare(this.departDoctor, this.$sn.getConfig('doctorTableSort'));
        }
      });
    },
    async goAppointment(schedule, value) {
      this.selected = {};
      this.scheduleTimeInfo = [];
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
        // 肾内科门诊、肾内科知名专家门诊 王荣 每周二排班在每周一12:00:00后才可以进行预约
        if (['574', '1103*'].includes(schedule.deptId) && schedule.doctorId === '2283' && new Date(schedule.scheduleDate).getDay() === 2) {
          const restrict = this.$sn.format.date(new Date(schedule.scheduleDate), 'yyyy-MM-dd', -1, 'day') + ' 12:00:00';
          if (this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd HH:mm:ss') < restrict) {
            this.$sn.assembly.modal({
              caption: Messages.APPOINT083,
              isCancel: false
            });
            return false;
          }
        }
        if (this.doctorInfo.frontExtend && this.$sn.validate.json(this.doctorInfo.frontExtend) && JSON.parse(this.doctorInfo.frontExtend).notReserve === '0') {
          if (!value) {
            this.$sn.assembly.modal({
              caption: Messages.APPOINT072,
              isCancel: false,
              success: (modal) => {
                if (modal.confirm) {
                  this.goAppointment(schedule, '1');
                }
              }
            });
            return false;
          }
        }
      }
      else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_QDQL) {
        if (this.doctorInfo.frontExtend && this.$sn.validate.json(this.doctorInfo.frontExtend)) {
          const caption = JSON.parse(this.doctorInfo.frontExtend).qdqlFX || JSON.parse(this.doctorInfo.frontExtend).qdqlCSJR;
          if (caption && !value) {
            this.$sn.assembly.modal({
              caption: caption,
              isCancel: false,
              captionConfirm: '知道了',
              success: (modal) => {
                if (modal.confirm) {
                  this.goAppointment(schedule, 'value');
                }
              }
            });
            return false;
          }
        }
      }
      if (['挂号', '预约'].includes(this.scheduleStatus(schedule))) {
        const entrance = await this.appointment_mixin_getEntranceInfo();
        const location = (schedule) => {
          return new Promise(resolve => {
            const fructify = {
              code: 0,
              msg: ''
            };
            if (this.$sn.getConfig('isTodayRegisterVerifyPosition') &&
            schedule.scheduleDate === this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd') &&
            !entrance.includes(this.$sn.utils.getLoginPhone())) {
              // TODO
              resolve(fructify);
            }
            else resolve(fructify);
          });
        };
        const verify = await location(schedule);
        if (verify.code === 0) this.getScheduleTime(schedule);
        else {
          this.$sn.assembly.modal({
            caption: verify.msg,
            isCancel: false
          });
        }
      }
      else {
        if (parseFloat(schedule.surplusNumber) <= 0) {
          if (this.$sn.getConfig('isShowScheduleFullOtherNoPrompt')) {
            this.$sn.assembly.toast({
              caption: Messages.APPOINT021,
              isCancel: false
            });
          }
          if (parseFloat(schedule.surplusNumber) === 0 && [this.perpetual.HOSPITAL_ID_SLX, this.perpetual.HOSPITAL_ID_EBH].includes(this.$sn.utils.getHospitalId())) {
            if (schedule.scheduleDate === this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')) {
              this.$sn.assembly.modal({
                caption: Messages.APPOINT105,
                isCancel: false
              });
            }
          }
        }
      }
    },
    getScheduleTime(schedule) {
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        url: Swagger.getOfflineScheduleTimeByCondition,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          businessType: schedule.businessType || this.perpetual.BASIC_BUSINESS_OFFLINE_CKQBYS,
          deptId: schedule.deptId,
          hosId: this.$sn.utils.getHospitalId(),
          openId: this.$sn.utils.getOpenId(),
          platformId: this.$sn.utils.getPlatformType(),
          scheduleItemCode: schedule.scheduleItemCode
        })
      }).then(result => {
        this.$sn.assembly.loading(false);
        let TimeDelay = '';
        if (this.$sn.getConfig('scheduleTimeDelay') === -1) {
          TimeDelay = '00:00:00';
        }
        else {
          TimeDelay = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HH:mm:ss', this.$sn.getConfig('scheduleTimeDelay'), 'second');
        }
        let caption = 'APPOINT014';
        if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_ETYY) caption = 'APPOINT024';
        if (result && result.code === 0 && result.data) {
          if (result.data.length > 0) {
            if (this.$sn.getConfig('isSortScheduleTime')) {
              result.data = this.$sn.format.digitalSort(result.data, '1', 'seq');
            }
            if (this.$sn.getConfig('isSorScheduleTimeByStartTime')) {
              result.data = this.$sn.format.digitalSort(result.data, '1', 'startTime');
            }
            if (schedule.scheduleDate === this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')) {
              this.scheduleTimeInfo = result.data.filter(res => {
                if (res.endTime) {
                  return res.endTime > TimeDelay;
                }
                else {
                  return res.startTime > TimeDelay;
                }
              });
            }
            else {
              this.scheduleTimeInfo = result.data;
            }
            if (this.scheduleTimeInfo.length > 0) {
              this.selected = schedule;
              if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL &&
              schedule.scheduleDate === this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd') &&
              this.scheduleTimeInfo.filter(res => parseFloat(res.surplusNumber) > 0 && res.state === '1').length > 0) {
                this.navigateUrl('/appointment/confirm', this.scheduleTimeInfo.find(res => parseFloat(res.surplusNumber) > 0 && res.state === '1'));
              }
            }
            else {
              this.$sn.assembly.modal({
                caption: Messages[caption],
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: Messages[caption],
              isCancel: false
            });
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: Messages.APPOINT015,
            isCancel: false
          });
        }
      });
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'exchange-doctor') {
        this.selectedArea = {};
        this.departDoctor = [];
        this.scheduleInfo = [];
        this.scheduleInfoFormat = {};
        this.tableInfo = {
          date: [],
          noon: []
        };
        this.pageCount = 1;
        this.selected = {};
        this.scheduleTimeInfo = [];
        this.doctorInfo = item;
        this.$sn.utils.setHospitalLocalStorage('Appointment_DoctorInfo', this.doctorInfo);
        this.formatDoctorInfo();
      }
      else if (url === 'exchange-area') {
        this.departDoctor = [];
        this.scheduleInfo = [];
        this.scheduleInfoFormat = {};
        this.tableInfo = {
          date: [],
          noon: []
        };
        this.pageCount = 1;
        this.selected = {};
        this.scheduleTimeInfo = [];
        this.selectedArea = item;
        this.$sn.utils.setHospitalSessionStorage('AppointmentArea', this.selectedArea);
        this.getDoctorSchedule();
        this.getDepartDoctor();
      }
      else if (url === '/appointment/confirm') {
        if (parseFloat(item.surplusNumber) > 0 && item.state === '1') {
          this.$sn.utils.setHospitalSessionStorage('Appointment_SelectedScheduleTimeInfo', {
            doctor: this.doctorInfo,
            schedule: this.selected,
            time: item
          });
          this.$router[type]({
            path: url,
            query: params || {}
          });
        }
      }
      else {
        this.appointment_mixin_navigateUrl(url, item, params, type);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.doctor {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;
    padding: 20px;

    .basic {
      width: 100%;
      height: 160px;
      margin: 20px 0;

      .sn-head-photo {
        margin-right: 10px;
      }

      .doctor-info {
        height: 160px;

        .doctor-sub {
          @include fs(14);

          height: 100%;
          border-left: 1px solid $main3;
          padding-left: 10px;
          margin-left: 10px;
        }

        .doctor-caption {
          @include fs(14);

          overflow-x: hidden;
          overflow-y: auto;
          width: 100%;
          margin-top: 10px;

          div {
            margin-bottom: 10px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }

      .depart-info {
        width: 400px;
        height: 160px;
        border-left: 1px solid $border1;
        padding-left: 20px;
        margin-left: 20px;

        .title {
          margin-bottom: 10px;
        }

        .depart-doctor {
          overflow: hidden;
          width: 100%;

          .doctor-recommend {
            @include fs(16);

            flex: 0 0 50%;
            margin-bottom: 10px;

            &:nth-child(2n+1) {
              padding-right: 20px;
            }

            &:nth-child(2n) {
              border-left: 1px solid $border1;
              padding-left: 20px;
            }
          }
        }
      }
    }

    .area {
      width: 100%;
      padding-bottom: 20px;

      .area-blank {
        @include fs(16);

        height: 40px;
        background-color: $background1;
        color: $text1;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 20px;
        position: relative;

        &:last-child {
          margin-right: 0;
        }

        &.interaction {
          background-color: $main;
          color: $white;

          &::before {
            content: '';
            width: 0;
            height: 0;
            border-top: 14px solid $main;
            border-right: 10px solid $transparent;
            border-left: 10px solid $transparent;
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }

    .pagination {
      overflow: hidden;
      width: 100%;
      padding-bottom: 20px;

      &-blank {
        @include fs(16);

        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        padding: 0 20px;
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }

        &.interaction {
          color: $text1;

          &:hover {
            background-color: $main4;
            color: $main3;
            border: 1px solid $main3;
          }
        }
      }
    }

    .schedule-blank {
      overflow: hidden;
      width: 100%;

      .sn-title {
        .title-caption {
          width: max-content;
          padding: 0 10px;
        }
      }

      .schedule-top {
        @include fs(20);

        width: 100%;
        height: 50px;
        background-color: $main;
        font-weight: bold;
        color: $white;
      }

      .chart-blank {
        @include fs(14);

        overflow: hidden;
        width: 100%;
        border-right: 1px solid $border1;
        border-bottom: 1px solid $border1;
        border-left: 1px solid $border1;
        margin-bottom: 20px;

        .chart-line {
          align-items: stretch;
          border-bottom: 1px solid $border1;

          &:last-child {
            border-bottom: none;
          }

          .chart-single {
            border-right: 1px solid $border1;
            padding: 10px 0;

            &:first-child {
              width: max-content;
            }

            &:last-child {
              border-right: none;
            }

            &.exist {
              background-color: $main4;
              color: $main;
            }

            &.disabled {
              background-color: $background1;
              color: $text3;
            }

            &.interaction {
              background-color: $main;
              color: $white;
            }
          }
        }
      }

      .schedule-time {
        overflow: hidden;
        width: 100%;
        padding-top: 20px;

        .region {
          flex: 0 0 20%;
          margin-bottom: 20px;

          .single {
            @include fs(14);

            width: 90%;
            height: 40px;
            background-color: $main;
            color: $white;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>
